import { FullLanguage } from '../models/language';

export const TextDirection = {
  LTR: 'ltr',
  RTL: 'rtl'
} as const;

export type TextDirection = typeof TextDirection[keyof typeof TextDirection];

export type LanguageKey =
  | 'Swedish'
  | 'English'
  | 'Finnish'
  | 'Somali'
  | 'Russian'
  | 'Arabic'
  | 'Spanish'
  | 'Tigrinya'
  | 'Kurdish'
  | 'Persian'
  | 'Turkish';

export const Swedish: FullLanguage = {
      name: 'Svenska/Swedish',
      code: 1053,
      resource: 'sv-SE',
      country: 'Svenska',
      rtl: false,
      careproviderName: 'Svenska'
};

export const English: FullLanguage = {
      name: 'English/Engelska',
      code: 1033,
      resource: 'en-US',
      country: 'Engelska',
      rtl: false,
      careproviderName: 'Engelska'
    };
export const Finnish: FullLanguage = {
      name: 'Suomeksi/Finska',
      code: 1035,
      resource: 'fi-FI',
      country: 'Finska',
      rtl: false,
      careproviderName: 'Finska'
    }
export const Somali: FullLanguage = {
      name: 'Soomaali/Somaliska',
      code: 1143,
      resource: 'so',
      country: 'Somaliska',
      rtl: false,
      careproviderName: 'Somaliska'
    };
export const Russian: FullLanguage = {
      name: 'Pусский/Ryska',
      code: 1049,
      resource: 'ru',
      country: 'Ryska',
      rtl: false,
      careproviderName: 'Ryska'
    };
export const Arabic: FullLanguage = {
      name: 'لعربية/Arabiska',
      code: 1025,
      resource: 'ar',
      country: 'Arabiska',
      rtl: true,
      careproviderName: 'Arabiska'
    };
export const Spanish: FullLanguage = {
      name: 'Español/Spanska',
      code: 1034,
      resource: 'es',
      country: 'Spanska',
      rtl: false,
      careproviderName: 'Spanska'
    };
export const Tigrinya: FullLanguage = {
      name: 'ትግርኛ/Tigrinska',
      code: 1139,
      resource: 'ti',
      country: 'Tigrinska',
      rtl: false,
      careproviderName: 'Tigrinska'
    };
export const Kurdish: FullLanguage = {
      name: 'Soranî/Sydkurdiska',
      code: 146,
      resource: 'ku',
      country: 'Sydkurdiska',
      rtl: true,
      careproviderName: 'Sydkurdiska'
    };
export const Persian: FullLanguage = {
      name: 'فارسی/Persiska',
      code: 1065,
      resource: 'fa',
      country: 'Persiska',
      rtl: true,
      careproviderName: 'Persiska'
    };
export const Turkish: FullLanguage = {
      name: 'Türkçe/Turkiska',
      code: 1055,
      resource: 'tr',
      country: 'Turkiska',
      rtl: false,
      careproviderName: 'Turkiska'
    };

export const Languages: Record<LanguageKey, FullLanguage> = {
    Swedish : Swedish,
    English : English,
    Finnish : Finnish,
    Somali : Somali,
    Russian : Russian,
    Arabic : Arabic,
    Spanish : Spanish,
    Tigrinya : Tigrinya,
    Kurdish : Kurdish,
    Persian : Persian,
    Turkish : Turkish
};

export const LanguageList: FullLanguage[] = [
    Swedish,
    English,
    Finnish,
    Somali,
    Russian,
    Arabic,
    Spanish,
    Tigrinya,
    Kurdish,
    Persian,
    Turkish
]

// Precomputed maps for efficient lookups
export const LanguageByCode = new Map<number, FullLanguage>(
  LanguageList.map((l) => [l.code, l])
);

export const LanguageByResource = new Map<string, FullLanguage>(
  LanguageList.map((l) => [l.resource.toLowerCase(), l])
);